import script from "./Texture.vue?vue&type=script&setup=true&lang=js"
export * from "./Texture.vue?vue&type=script&setup=true&lang=js"

import "./Texture.vue?vue&type=style&index=0&id=aad8a628&lang=postcss&scoped=true"

import exportComponent from "/builds/atlatl-software/atlatl-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aad8a628"]])

export default __exports__